<template>
  <section>
    <IHeader />
    <main>
      <keep-alive :include="include">
        <router-view :key="$route.path"></router-view>
      </keep-alive>
    </main>
    <IFooter />
  </section>
</template>

<script>
import IHeader from "@/components/base/Header";
import IFooter from "@/components/base/Footer";
import cookie from '@/util/cookie';
export default {
  props: {},
  data() {
    return {
      activePath: "",
      include: [],
    };
  },
  mounted() {
    this.activePath = this.$route.path;
    setTimeout(() => {
      if(!cookie.has('qrCodeVisible')){
        this.$store.dispatch('updateQrCodeVisible',true);
        cookie.setDaily('qrCodeVisible',true)
      }
    }, 1000);

    document.addEventListener('mousemove', this.handleCloseQrCodeVisible);
    document.addEventListener('click', this.handleCloseQrCodeVisible);
  },
  destroyed() {
    document.removeEventListener('mousemove', this.handleCloseQrCodeVisible);
    document.removeEventListener('click', this.handleCloseQrCodeVisible);
  },
  computed: {
  },
  components: { IHeader, IFooter },
  methods: {
    handleSelect(val) {
      this.activePath = val;
      this.$router.push(val);
    },
    isIncludesPath(path) {
      return path.indexOf(this.activePath) > -1;
    },
    handleCloseQrCodeVisible(){
      if(this.$store.state.qrCodeVisible){
        this.$store.dispatch('updateQrCodeVisible',false);
      }
    }
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
main {
  min-height: calc(100vh - 190px);
}
</style>
